export default __webpack_public_path__ + "static/media/Network-&-Security-Liability.afe0ba7b.png";